const KEY_PREFIX = "guide-nudge-dismissed:";

// One "Don't show again" click anywhere silences the nudge on EVERY page.
// Legacy per-page keys written before this existed are still honored.
const GLOBAL_KEY = `${KEY_PREFIX}__all__`;
let globalDismissed = false;

// Module-level in-memory cache of dismissed page keys. localStorage is the
// durable source of truth, but a just-written dismiss must survive a parent
// re-mount that resets the banner's local state before the next localStorage
// read settles (the Properties-page dismiss bug). This cache is written
// synchronously by `dismissNudge` and checked first by `isNudgeDismissed`, so a
// dismiss takes effect immediately even if localStorage is briefly stale,
// throws, or the banner instance is replaced.
const dismissedCache = new Set<string>();

function storageKey(pageKey: string): string {
  return `${KEY_PREFIX}${pageKey}`;
}

export function isNudgeDismissed(pageKey: string): boolean {
  if (globalDismissed || dismissedCache.has(pageKey)) return true;
  try {
    if (localStorage.getItem(GLOBAL_KEY) === "1") {
      globalDismissed = true;
      return true;
    }
    const dismissed = localStorage.getItem(storageKey(pageKey)) === "1";
    if (dismissed) dismissedCache.add(pageKey);
    return dismissed;
  } catch {
    return false;
  }
}

/** "Don't show again" — silence the nudge bubble on every page, everywhere. */
export function dismissAllNudges(): void {
  globalDismissed = true;
  try {
    localStorage.setItem(GLOBAL_KEY, "1");
  } catch {
  }
}

export function dismissNudge(pageKey: string): void {
  dismissedCache.add(pageKey);
  try {
    localStorage.setItem(storageKey(pageKey), "1");
  } catch {
  }
}

/**
 * Test-only: clear the module-level in-memory dismiss cache. Production code
 * never needs this (dismissals are permanent), but tests that reset
 * `localStorage` between cases must also drop the cache or a dismiss written by
 * one test would leak into the next.
 */
export function __resetNudgeDismissCacheForTest(): void {
  dismissedCache.clear();
  globalDismissed = false;
}
